module.exports = __webpack_public_path__ + "img/scienceBorder_right.93813ec1.png";